jQuery(function () {
  const informations = $('#google_maps_data').val() || '{}'
  const parsedInfo = JSON.parse(informations)

  const height = parsedInfo && parsedInfo.height + 'px'
  $('#map').css({ height: height || '654px' })

  // Create the script tag, set the appropriate attributes
  var script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?key=${parsedInfo.key}&callback=initMap&libraries=&v=weekly`
  script.defer = true

  // Attach your callback function to the `window` object
  window.initMap = initMap

  // Append the 'script' element to 'head'
  document.head.appendChild(script)

  $('.filter.offices_map a').on('click', function (event) {
    event.preventDefault()
    const anchor = $(this)
    const location = anchor.prop('title')

    // functions comes from file contact-us.js
    const urlParams = getAllParamsFromUrl()
    urlParams.offices_location = location
    handleParametersOnURL(urlParams)
    window.location.reload(true)
  })

  // Change value of the selected service area
  $('.dropdown__wrapper.offices_map li').on('click', function () {
    const item = $(this)
    const val = item.attr('rel')
    $('.dropdown__wrapper.offices_map')
      .find('.styledSelect')
      .attr('value', val)
  })

  // Filter a service area on mobile mode
  $('.optionsBtn.offices_map').on('click', function () {
    const selected = $('.dropdown__wrapper.offices_map').find('.styledSelect')
    const serviceArea = selected.attr('value')
    const urlParams = getAllParamsFromUrl()

    urlParams.offices_location = serviceArea
    handleParametersOnURL(urlParams)
    window.location.reload(true)
  })

  // When clicking the button to open the service area filters
  // we guarantee that the select filter is the one on the URL
  $('.filterBtn.offices_map').on('click', function () {
    const mobileAllOffices = $('.dropdown__wrapper.offices_map')
    const urlParams = getAllParamsFromUrl()
    const serviceArea = urlParams.offices_location
    const listItem = mobileAllOffices.find(`li[rel=${serviceArea}]`)

    if (listItem.length) {
      listItem.trigger('click')
    } else {
      mobileAllOffices.find('li').first().trigger('click')
    }
  })
})

function initMap () {
  headquarterMap()

  const informations = $('#google_maps_data').val() || '{}'
  const parsedInfo = JSON.parse(informations)

  if (
    !parsedInfo.center ||
    !parsedInfo.center.lat ||
    !parsedInfo.center.lng ||
    !parsedInfo.offices ||
    parsedInfo.offices.length === 0
  ) { return }

  const styledMapType = getStyledMapType(parsedInfo.style)
  // Set Map
  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: parsedInfo.zoom,
    center: { lat: parsedInfo.center.lat, lng: parsedInfo.center.lng }
  })

  map.mapTypes.set('styled_map', styledMapType)
  map.setMapTypeId('styled_map')

  setMarkers(map, parsedInfo.offices)
}

function setMarkers (map, data) {
  const svgMarker = '<svg viewBox="448 311 24 32" xmlns="http://www.w3.org/2000/svg"><path d="M 459.66926 341.3333 C 459.66926 341.3333 470.33466 328.5 470.33466 323 C 470.33466 317.5 466.77865 312 459.66926 312 C 452.5573 312 449.0013 317.5 449.0013 323 C 449.0013 328.5 459.66926 341.3333 459.66926 341.3333 Z M 459.66797 328.6167 L 459.66797 328.6167 C 456.4093 328.6167 453.7682 325.9511 453.7682 322.6667 C 453.7682 319.3823 456.4093 316.7167 459.66797 316.7167 C 462.92466 316.7167 465.56777 319.3823 465.56777 322.6667 C 465.56777 325.9511 462.92466 328.6167 459.66797 328.6167 Z" fill="#007b4e" stroke="#007b4e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>'
  const markers = []

  const infoWindows = []

  let infowindow = new google.maps.InfoWindow({})

  for (let i = 0; i < data.length; i++) {
    const office = data[i]
    office.location.forEach((officeCoord, index) => {
      const marker = new google.maps.Marker({
        position: { lat: officeCoord.lat, lng: officeCoord.lng },
        map,
        icon: {
          url:
            'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgMarker),
          scaledSize: new google.maps.Size(32, 32)
        },
        title: office.name
      })

      // Add event when clicking in a marker from the map
      marker.addListener('click', () => {
        // // First zoom when clicking on marker
        // if (map.getZoom() < 8) {
        //   map.setZoom(map.getZoom() + 2)
        //   map.setCenter(marker.getPosition())
        // }
        // // Then Show info box
        // else {
          infowindow.close()
          infowindow = new google.maps.InfoWindow({
            content: getOfficeInfo(office, index),
            maxWidth: '266',
            minWidth: '280'
          })
          infowindow.open(map, marker)
        // }
      })

      markers.push(marker)
    })
  }

  return markers
}

function headquarterMap () {
  const svgMarker = '<svg viewBox="448 311 24 32" xmlns="http://www.w3.org/2000/svg"><path d="M 459.66926 341.3333 C 459.66926 341.3333 470.33466 328.5 470.33466 323 C 470.33466 317.5 466.77865 312 459.66926 312 C 452.5573 312 449.0013 317.5 449.0013 323 C 449.0013 328.5 459.66926 341.3333 459.66926 341.3333 Z M 459.66797 328.6167 L 459.66797 328.6167 C 456.4093 328.6167 453.7682 325.9511 453.7682 322.6667 C 453.7682 319.3823 456.4093 316.7167 459.66797 316.7167 C 462.92466 316.7167 465.56777 319.3823 465.56777 322.6667 C 465.56777 325.9511 462.92466 328.6167 459.66797 328.6167 Z" fill="#007b4e" stroke="#007b4e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>'
  const informations = $('#google_maps_data').val()
  const parsedInfo = JSON.parse(informations)
  const headquarterGeopoint = parsedInfo.headquartes_geo

  if (
    !headquarterGeopoint ||
    !headquarterGeopoint[0].location ||
    !headquarterGeopoint[0].location[0].lat ||
    !headquarterGeopoint[0].location[0].lng
  ) { return }

  const styledMapType = getStyledMapType(parsedInfo.style)

  const headquarterMap = new google.maps.Map(
    document.getElementById('headquarters_map'),
    {
      zoom: 13,
      center: { lat: headquarterGeopoint[0].location[0].lat, lng: headquarterGeopoint[0].location[0].lng },
      gestureHandling: 'none',
      zoomControl: false,
      disableDefaultUI: true,
      draggableCursor: 'default'
    }
  )

  headquarterMap.mapTypes.set('styled_map', styledMapType)
  headquarterMap.setMapTypeId('styled_map')

  let infowindow = new google.maps.InfoWindow({})

  headquarterGeopoint.forEach(geoPoint => {
    const marker = new google.maps.Marker({
      position: { lat: geoPoint.location[0].lat, lng: geoPoint.location[0].lng },
      map: headquarterMap,
      clickable: true,
      icon: {
        url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgMarker),
        scaledSize: new google.maps.Size(32, 32)
      }
    })

    marker.addListener('click', () => {
      infowindow.close()
      infowindow = new google.maps.InfoWindow({
        content: getOfficeInfo(geoPoint)
      })
      infowindow.open(headquarterMap, marker)
    })
  })
}

function getStyledMapType (customStyle) {
  try {
    return new google.maps.StyledMapType(JSON.parse(customStyle), {
      name: 'Styled Map'
    })
  } catch (error) {
    return new google.maps.StyledMapType([], { name: 'Styled Map' })
  }
}

function getOfficeInfo (office, index = 0) {
  const svgIcon = `<svg style="display: inline-block; margin-bottom: 6px; margin-right: 9px;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.0001 1.61102L1.61133 7.34879" stroke="#007B4E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.26221 14.9998L15 1.61102" stroke="#007B4E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M1.61133 7.349L7.34909 9.26159L9.26235 15" stroke="#007B4E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`

  const officeInfo = `
    <div class="officeInfo">
      ${office.name ? `<h1>${office.name}</h1>` : ''}

      ${
        office.address[index]
          ? `<h5>Adresse</h5>
      <p>${office.address[index]}</p>`
          : ''
      }

      ${
        office.location[index] ? `<p><a target="_blank" href="https://www.google.com/maps/@?api=1&map_action=map&center=${office.location[index].lat},${office.location[index].lng}"><span>${svgIcon}</span>Åpne i kart</a></p>`
          : ''
      }

      ${
        office.contact
          ? `<h5>Kontakt</h5>
      <p>${office.contact}</p>`
          : ''
      }

    </div>
  `

  return officeInfo
}
